import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";

/**
 * Clock component: shows current time and updates every second.
 * Props:
 * - locale: BCP-47 locale string (default: "it-IT")
 * - showSeconds: whether to display seconds (default: true)
 * - variant: MUI Typography variant (default: "body2")
 * - style: inline styles for Typography
 */
const Clock = ({
  locale = "it-IT",
  showSeconds = true,
  variant = "body2",
  style,
}) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const options = {
    hour: "2-digit",
    minute: "2-digit",
    ...(showSeconds ? { second: "2-digit" } : {}),
  };

  return (
    <Typography variant={variant} style={style} component="span">
      {now.toLocaleTimeString(locale, options)}
    </Typography>
  );
};

export default Clock;